import { testimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
      {testimonials.map((item) => (
        <figure key={item.nickname} className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <div className="flex items-center gap-1 text-accent-500">
            {[0, 1, 2, 3, 4].map((i) => (
              <i key={i} className="ri-star-fill text-sm"></i>
            ))}
          </div>
          <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800 md:text-[15px]">
            {item.content}
          </blockquote>
          <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
              {item.nickname.slice(0, 1)}
            </span>
            <span>
              <span className="block text-sm font-semibold text-foreground-950">{item.nickname}</span>
              <span className="block text-xs text-foreground-500">{item.role}</span>
            </span>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}